import { Navigate, useParams } from "react-router-dom";
export default function CryptoLegacyRedirect({ resource }: { resource: string }) {
  const { id } = useParams();
  return <Navigate to={`/crypto/${resource}/${encodeURIComponent(id || "")}`} replace />;
}
